import { Grid, Typography } from '@mui/material';
import styles from '../Information/Information.module.scss';
import { useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../infrastructure/backendService';
import { CMS_BASE_URL } from '../../config/apiUrl';

const OverviewCms = () => {
    const [html, setHTML] = useState({ __html: '' });
  
    useEffect(() => {
      const fetchData = async () => {
        try {
          const res = await apiRequest({
            basePath: `${CMS_BASE_URL}`,
            method: 'GET',
            endpoint: '/wp-json/wp/v2/hccc-page?slug=information-overview',
            includeToken: false,
          });
  
          const acfContent = res.data[0]?.acf?.hccc_page || '';
          const styledContent = acfContent.replace(
            /<p class="MuiTypography-root MuiTypography-body1 _headername_8c7n3_281 css-9l3uo3">/g,
            `<p class="${styles.headername}">`
          );
          setHTML({ __html: styledContent });
        } catch (error) {
          console.log('Error fetching data:', error);
        }
      };
      fetchData();
    }, [styles.headername]);
    return (
        <>
            <div className={styles.OverView}>
                <Typography className={styles.typoGraphyHeading}>
                    Overview
                </Typography>
                <div dangerouslySetInnerHTML={html} />
            </div>
          
        </>
    )
}
export default OverviewCms;